import { Box, Button, Popover, TextField } from "@mui/material";
import { RANGE_GROUPING_LABEL_EDITOR_MIN_WIDTH } from "components/reportsV3/types/constants";
import { ignoreBackdropClose } from "components/reportsV3/utils/literalEditUtils";
import * as labels from "config.labels";
import React, { useEffect, useRef, useState } from "react";
import * as staticDataHooks from "store/hooks/staticDataHooks";

export const RangeGroupingLabelEditor = ({
  open,
  anchorEl,
  initialText,
  placeholder,
  onApply,
  onClose,
}) => {
  const translateLabels = staticDataHooks.useTranslator("uiLabels");
  const [text, setText] = useState(initialText ?? "");

  const wasOpen = useRef(false);

  useEffect(() => {
    if (open && !wasOpen.current) setText(initialText ?? "");
    wasOpen.current = open;
  }, [open, initialText]);

  const handleSave = () => {
    onApply(text);
    onClose();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSave();
    } else if (event.key === "Escape") {
      onClose();
    }
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={ignoreBackdropClose(onClose)}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <TextField
        size={"small"}
        autoFocus
        sx={{ minWidth: RANGE_GROUPING_LABEL_EDITOR_MIN_WIDTH, m: 1 }}
        placeholder={placeholder}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        inputProps={{
          "aria-label": translateLabels(
            labels.RANGE_GROUPING_DIALOG_EDIT_LABEL,
            { default: "Edit label" }
          ),
        }}
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end", px: 1, pb: 1 }}>
        <Button size={"small"} onClick={handleSave}>
          {translateLabels(labels.RANGE_GROUPING_DIALOG_SAVE, {
            default: "Save",
          })}
        </Button>
        <Button size={"small"} onClick={onClose} color={"inherit"}>
          {translateLabels(labels.RANGE_GROUPING_DIALOG_CANCEL, {
            default: "Cancel",
          })}
        </Button>
      </Box>
    </Popover>
  );
};

export default RangeGroupingLabelEditor;
